<template>
  <bpb-scroller-item v-if="targetId" class="topic-jumpletters__item">
    <a v-smooth-scroll :href="`#${targetId}`" class="topic-jumpletters__button">
      <slot></slot>
    </a>
  </bpb-scroller-item>
  <bpb-scroller-item
    v-else
    class="topic-jumpletters__item topic-jumpletters__item--is-disabled"
  >
    <span class="topic-jumpletters__span">
      <slot></slot>
    </span>
  </bpb-scroller-item>
</template>

<script>
import { ScrollerEventBus } from '@js/eventBus';
import { animationFrame } from '@js/utils/animation';

export default {
  props: {
    targetId: {
      type: String,
    },
  },
};
</script>
